;
define("cart_promocode_notifications.tpl", function(){});

